/* eslint-disable react/prop-types */
/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import store from "../../store";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import Theme from "../../theme/theme";
import PreferredSuppliersList from "./PreferredSuppliersList";

const ProviderComponent: FunctionComponent = () => (
  <ErrorBoundary>
    <Theme>
      <Provider store={store}>
        <PreferredSuppliersList />
      </Provider>
    </Theme>
  </ErrorBoundary>
);

export default ProviderComponent;
